<nav
  motif-vertical-navigation
  [show]="showMenu"
  id="vertical-navigation-menu"
  [ngClass]="{ dashboard: isDashboard }"
>
  <ul motif-vertical-navigation-menu position="top">
    @for (item of items; track item?.label) {
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { item, index: $index }"
      >
      </ng-container>
    }
    <ng-template #itemTemplate let-item="item">
      <li
        class="side-bar-list"
        motif-vertical-navigation-menu-item
        [class.disabled]="isSideNavItemDisabled(item)"
      >
        <a
          class="menu-link"
          motif-vertical-navigation-menu-link
          (click)="!isSideNavItemDisabled(item) && menuNavigationHandler(item)"
          vertical-navigation-menu-item-active
          [verticalNavigationMenuItemActiveOptions]="{ exact: item.exact }"
          [attr.aria-disabled]="isSideNavItemDisabled(item) || null"
        >
          @if (item?.icon) {
            <motif-icon
              class="side-bar-icons"
              motif-tooltip="{{ item?.label }}"
              [hideIconClose]="true"
              [iconFunction]="item?.icon"
            ></motif-icon
            ><span>{{ item?.label }}</span>
          } @else {
            <motif-icon
              class="side-bar-custom-icons"
              src="{{ item?.src }}"
            ></motif-icon>
            <span class="custom-label">{{ item?.label }}</span>
          }
        </a>
      </li>
    </ng-template>
  </ul>

  <ul motif-vertical-navigation-menu position="bottom">
    <li
      motif-vertical-navigation-menu-item
      [class.disabled]="isSettingsDisabled()"
    >
      <a
        class="menu-link"
        [ngClass]="{ 'disabled-icon': disableSettingsIcon }"
        motif-vertical-navigation-menu-link
        (click)="!isSettingsDisabled() && settingsNavigationHandler()"
        [attr.aria-disabled]="isSettingsDisabled() || null"
      >
        <motif-icon
          class="side-bar-icons"
          [ngClass]="{ 'disabled-icon': disableSettingsIcon }"
          [iconFunction]="settingsIcon"
          motif-tooltip="{{ 'Settings' | translate }}"
          [hideIconClose]="true"
        ></motif-icon>
        <span>{{ "Settings" | translate }}</span>
      </a>
    </li>
  </ul>
</nav>
